import { resolveCurrencyImage } from "@/helpers/currencyImage"
import { compareCurrencyCodes } from "@/helpers/currencyPresentation"
import {
  buildScaleIndex,
  formatMoney,
  parseAmount,
  pluralCountAtScale
} from "@/helpers/money"
import { IMobRewardCurrency } from "@/hooks/useMobReward/types"
import { ICurrencyEntry } from "@/store/apis/catalogsAPI/catalogs.types"
import { IMobKillCurrencyDrop } from "@/store/apis/mobsAPI/mobs.types"

export const buildRewardCurrencies = (
  drops: readonly IMobKillCurrencyDrop[],
  currencies: readonly ICurrencyEntry[],
  locale: string,
  order: readonly string[]
): IMobRewardCurrency[] => {
  const scales = buildScaleIndex(currencies)
  return drops
    .slice()
    .sort((a, b) => compareCurrencyCodes(a.currencyCode, b.currencyCode, order))
    .flatMap((drop): IMobRewardCurrency[] => {
      const scale = scales.get(drop.currencyCode)
      const amount = parseAmount(drop.amount)
      if (scale === undefined || amount === null) {
        return []
      }
      const amountText = formatMoney(drop.amount, scale, locale)
      return amountText === null
        ? []
        : [
            {
              currencyCode: drop.currencyCode,
              amountText,
              unitCount: pluralCountAtScale(amount, scale),
              iconUrl: resolveCurrencyImage(drop.currencyCode)
            }
          ]
    })
}

export const isRewardNothing = (
  drops: readonly unknown[],
  currencies: readonly unknown[]
): boolean => drops.length === 0 && currencies.length === 0
